import { Suspense, lazy, ElementType } from "react";
// components
import LoadingScreen from "../components/loading-screen";

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const Login = Loadable(
  lazy(() => import("../pages/auth/AuthLoginForm"))
);

export const Dashboard = Loadable(lazy(() => import("../pages/Dashboard")));
export const Users = Loadable(lazy(() => import("../pages/Users")));
export const Currency = Loadable(lazy(() => import("../pages/Currency")));
export const Deposits = Loadable(lazy(() => import("../pages/Deposits")));
export const Withdraw = Loadable(lazy(() => import("../pages/Withdraw")));
export const Reward = Loadable(lazy(() => import("../pages/Reward")));
export const ClaimedRewards = Loadable(
  lazy(() => import("../pages/ClaimedRewards"))
);
export const Commissions = Loadable(lazy(() => import("../pages/Commissions")));
export const Settings = Loadable(lazy(() => import("../pages/Settings")));

export const Page404 = Loadable(lazy(() => import("../pages/Page404")));
